import { connect } from 'react-redux'
import StompunktPage from './StompunktPage'
import { currentHeavyStompunkt } from '../../selectors/currentStompunkt'

const mapStateToProps = (state, ownProps) => ({
	stompunkt: currentHeavyStompunkt(state),
	srid: state.srid,
	showPermalink: state.showPermalink,
})

export default connect(mapStateToProps)(StompunktPage);



// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktPageContainer.js